import { useLocation } from "react-router-dom";
import * as Styles from "./Anamnese.styles";
import { useState } from "react";
import {
  getOnboardingStorage,
  setOnboardingStorage,
  ANAMNESE_STEP,
} from "../storage";
import { routerNameToSave } from "helper/routeHelper";
import { useRouteNavigation } from "hooks/useRouteNavigation";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useNavigationRegistration } from "hooks/useNavigationRegistration";

import { ReactComponent as HourglassIcon } from "assets/images/shapes/hourglass.svg";
import { ReactComponent as TriangleIcon } from "assets/images/shapes/triangle.svg";
import { ReactComponent as RectangleIcon } from "assets/images/shapes/rectangle.svg";
import { ReactComponent as InvertedTriangleIcon } from "assets/images/shapes/inverted-triangle.svg";
import { ReactComponent as CircleIcon } from "assets/images/shapes/circle.svg";

import { Laugh, Sad, Smile, Angry, Face } from "assets/images/shapes/Shapes";

// Define the questions and options with exact emojis from the reference image
const questionnaireData = [
  {
    id: "stress",
    title: "Stresslevel",
    description: "Wie hoch ist dein aktuelles Stresslevel?",
    options: [
      { value: "0", icon: Laugh, displayValue: "0" },
      { value: "1", icon: Smile, displayValue: "1" },
      { value: "2-3", icon: Face, displayValue: "2-3" },
      { value: "4-5", icon: Sad, displayValue: "4-5" },
      { value: "more_than_5", icon: Angry, displayValue: ">5" },
    ],
  },
  {
    id: "body_shape",
    title: "Körperfett",
    description: "Welche Körperform beschreibt dich am besten?",
    options: [
      { value: "hourglass", icon: HourglassIcon, displayValue: "" },
      { value: "triangle", icon: InvertedTriangleIcon, displayValue: "" },
      { value: "rectangle", icon: RectangleIcon, displayValue: "" },
      { value: "inverted_triangle", icon: TriangleIcon, displayValue: "" },
      { value: "circle", icon: CircleIcon, displayValue: "" },
    ],
    helpAvailable: true,
  },
  {
    id: "sport_activity",
    title: "Sportliche Aktivität",
    description: "Wie häufig treibst du Sport in der Woche?",
    options: [
      { value: "0", label: "0", displayValue: "0" },
      { value: "1", label: "1", displayValue: "1" },
      { value: "2-3", label: "2-3", displayValue: "2-3" },
      { value: "4-5", label: "4-5", displayValue: "4-5" },
      { value: "more_than_5", label: ">5", displayValue: ">5" },
    ],
  },
  {
    id: "daily_activity",
    title: "Tägliche Aktivität",
    description: "Wie viel Schritte machst du am Tag?",
    options: [
      { value: "less_than_5000", label: "<5.000", displayValue: "<5.000" },
      { value: "5000-8000", label: "5.000-8.000", displayValue: "5.000-8.000" },
      {
        value: "8001-10000",
        label: "8.001-10.000",
        displayValue: "8.001-10.000",
      },
      {
        value: "10001-12000",
        label: "10.001-12.000",
        displayValue: "10.001-12.000",
      },
      { value: "more_than_12000", label: ">12.000", displayValue: ">12.000" },
    ],
  },
  {
    id: "smoking",
    title: "Rauchen",
    description: "Wie viele Zigaretten rauchst du am Tag?",
    options: [
      { value: "0", label: "0", displayValue: "0" },
      { value: "1-3", label: "1-3", displayValue: "1-3" },
      { value: "4-10", label: "4-10", displayValue: "4-10" },
      { value: "11-20", label: "11-20", displayValue: "11-20" },
      { value: "more_than_20", label: ">20", displayValue: ">20" },
    ],
  },
  {
    id: "alcohol",
    title: "Alkohol",
    description: "Wie häufig trinkst du Alkohol in der Woche?",
    options: [
      { value: "0", label: "0", displayValue: "0" },
      { value: "1", label: "1", displayValue: "1" },
      { value: "2", label: "2", displayValue: "2" },
      { value: "3", label: "3", displayValue: "3" },
      { value: "more_than_3", label: ">3", displayValue: ">3" },
    ],
  },
  {
    id: "fruit_veg",
    title: "Obst & Gemüse",
    description: "Wie häufig isst du Obst und Gemüse am Tag?",
    options: [
      { value: "0", label: "0", displayValue: "0" },
      { value: "1", label: "1", displayValue: "1" },
      { value: "2", label: "2", displayValue: "2" },
      { value: "3-5", label: "3-5", displayValue: "3-5" },
      { value: "more_than_5", label: ">5", displayValue: ">5" },
    ],
  },
  {
    id: "meal_frequency",
    title: "Mahlzeitenfrequenz",
    description: "Wie viel Mahlzeiten nimmst du pro Tag zu dir?",
    options: [
      { value: "1", label: "1", displayValue: "1" },
      { value: "2", label: "2", displayValue: "2" },
      { value: "3", label: "3", displayValue: "3" },
      { value: "4", label: "4", displayValue: "4" },
      { value: "more_than_4", label: ">4", displayValue: ">4" },
    ],
  },
  {
    id: "water_intake",
    title: "Trinken",
    description: "Wie viel Liter trinkst du am Tag?",
    options: [
      { value: "less_than_1", label: "<1", displayValue: "<1" },
      { value: "1", label: "1", displayValue: "1" },
      { value: "1-2", label: "1-2", displayValue: "1-2" },
      { value: "2-3", label: "2-3", displayValue: "2-3" },
      { value: "more_than_3", label: ">3", displayValue: ">3" },
    ],
  },
  {
    id: "cravings",
    title: "Heißhunger",
    description: "Wie häufig hast du Heißhungerattacken am Tag?",
    options: [
      { value: "0", label: "0", displayValue: "0" },
      { value: "1", label: "1", displayValue: "1" },
      { value: "2", label: "2", displayValue: "2" },
      { value: "3", label: "3", displayValue: "3" },
      { value: "more_than_3", label: ">3", displayValue: ">3" },
    ],
  },
  {
    id: "mood_swings",
    title: "Stimmungsschwankungen",
    description: "Wie häufig kommt das in der Woche vor?",
    options: [
      { value: "0", label: "0", displayValue: "0" },
      { value: "1", label: "1", displayValue: "1" },
      { value: "2", label: "2", displayValue: "2" },
      { value: "3", label: "3", displayValue: "3" },
      { value: "more_than_3", label: ">3", displayValue: ">3" },
    ],
  },
  {
    id: "weakness",
    title: "Schwächegefühl",
    description: "Wie oft fühlst du dich schlapp in der Woche?",
    options: [
      { value: "0", label: "0", displayValue: "0" },
      { value: "1", label: "1", displayValue: "1" },
      { value: "2", label: "2", displayValue: "2" },
      { value: "3", label: "3", displayValue: "3" },
      { value: "more_than_3", label: ">3", displayValue: ">3" },
    ],
  },
];

function Anamnese({ currentPath }) {
  const location = useLocation();
  const { handleNavigate, handleNavigateBack } = useRouteNavigation();

  routerNameToSave(location.state?.params ?? "");

  // Initialize state from storage or as an empty object
  const [selections, setSelections] = useState(
    () => getOnboardingStorage(ANAMNESE_STEP) || {}
  );
  const [validationError, setValidationError] = useState(null);

  // Handle selection change for a specific question
  const handleSelection = (questionId, optionValue) => {
    setSelections((prev) => ({
      ...prev,
      [questionId]: optionValue,
    }));
    setValidationError(null); // Clear error on selection
  };
  console.log(selections, questionnaireData.length);

  const handleNextPage = () => {
    // Validate if all questions have been answered
    if (Object.keys(selections).length !== questionnaireData.length) {
      return setValidationError("Bitte beantworte alle Fragen."); // Simple validation message
    }

    setOnboardingStorage(ANAMNESE_STEP, selections);
    handleNavigate(currentPath);
  };

  const goBack = () => {
    handleNavigateBack(currentPath);
  };

  useNavigationRegistration(goBack, handleNextPage);
  function formatRangeDisplay(rangeString, isSelected) {
    if (rangeString.includes(">") || rangeString.includes("<")) {
      return (
        <Styles.OptionLabel selected={isSelected}>
          {rangeString}
        </Styles.OptionLabel>
      );
    }
    const [min, max] = rangeString.split("-");
    return (
      <Styles.RangeDisplay>
        <span>{min}</span>
        <span>-</span>
        <span>{max}</span>
      </Styles.RangeDisplay>
    );
  }
  return (
    <Styles.ContentWrapper>
      <Styles.PageTitle>Lernen wir deinen Alltag kennen.</Styles.PageTitle>
      <Styles.PageSubtitle>
        Die folgenden Fragen helfen uns ein besseres Verständnis zu bekommen.
      </Styles.PageSubtitle>

      <Styles.CardsContainer>
        {questionnaireData.map((question, index) => (
          <Styles.Card key={question.id}>
            <Styles.CardHeader>
              <Styles.CardTitle>{question.title}</Styles.CardTitle>
              {/* {question.helpAvailable && (
                <Styles.HelpLink>
                  <InfoCircleOutlined />
                  Auswahlhilfe
                </Styles.HelpLink>
              )} */}
            </Styles.CardHeader>
            <Styles.CardDescription>
              {question.description}
            </Styles.CardDescription>
            <Styles.OptionsGrid>
              {question.options.map((option) => {
                const isSelected = selections[question.id] === option.value;
                return (
                  <Styles.OptionItem
                    key={option.value}
                    selected={isSelected}
                    onClick={() => handleSelection(question.id, option.value)}
                  >
                    <Styles.OptionContent>
                      {option?.icon ? (
                        <Styles.OptionIcon selected={isSelected}>
                          <option.icon
                            stroke={2}
                            fill={isSelected ? "#2ECF96" : "#D9D9D9"}
                          />
                        </Styles.OptionIcon>
                      ) : (
                        <Styles.OptionLabel selected={isSelected}>
                          {option.label.length > 6
                            ? formatRangeDisplay(option.label, isSelected)
                            : option.label}
                        </Styles.OptionLabel>
                      )}
                    </Styles.OptionContent>

                    {isSelected ? (
                      <Styles.SelectionIndicator />
                    ) : (
                      <Styles.EmptySquare />
                    )}
                  </Styles.OptionItem>
                );
              })}
            </Styles.OptionsGrid>
          </Styles.Card>
        ))}
      </Styles.CardsContainer>

      {validationError && (
        <p style={{ color: "red", textAlign: "center", marginTop: "10px" }}>
          {validationError}
        </p>
      )}
    </Styles.ContentWrapper>
  );
}

export default Anamnese;
